var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-chart-warp"},[_c('div',{ref:`history-${_vm.chartId}`,staticClass:"history-chart",class:[_vm.statusClass]}),(_vm.useHumiditySectionLine)?_c('div',{staticClass:"history-ts"},[_vm._v("适用湿度范围 "+_vm._s(_vm.range))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }